import * as React from "react";
import {cs} from "@Common/react/chain-services";
import {AddressModalP} from "./address-modal-p/address-modal-p";
import {ConfirmDialog} from "../../../../../../common/design2/dialogs/confirm-dialog/confirm-dialog";
import {DataTableF}    from "../../../../../../common/design2/data-table/data-table-f";

export const Table = ({records, countryCode, onAdd, onReplace, onReset, onDelete}) => cs(
    ["addressModal", (_, next) => AddressModalP({next})],
    ["confirmDialog", (_, next) => ConfirmDialog({next})],
    ({addressModal, confirmDialog}) => DataTableF({
        darkRows: "even",
        columns: Columns({countryCode}),
        rows: records.map((r, i) => {
            const fullName = [
                r.address.firstname,
                r.address.lastname,
            ].filter(v=>v).join(" ");

            const address = [
                r.address.aptNum,
                r.address.houseNum,
                r.address.street,
            ].filter(v=>v).join(" ");

            return {
                key: i,
                columns: [
                    {
                        text: fullName,
                        domAttrs: {
                            "xd-qa-type": "label",
                            "xd-qa-name": "Build Address List "+address+" Recipient Name",
                        },
                    },
                    {
                        text: address,
                        domAttrs: {
                            "xd-qa-type": "label",
                            "xd-qa-name": "Build Address List "+address,
                        },
                    },
                    {
                        text: r.address.city,
                        domAttrs: {
                            "xd-qa-type": "label",
                            "xd-qa-name": "Build Address List "+address+" City",
                        },
                    },
                    {
                        text: r.address.state,
                        domAttrs: {
                            "xd-qa-type": "label",
                            "xd-qa-name": "Build Address List "+address+" State",
                        },
                    },
                    {
                        text: r.address.zip,
                        domAttrs: {
                            "xd-qa-type": "label",
                            "xd-qa-name": "Build Address List "+address+" Zip",
                        },
                    },
                    {
                        actions: [
                            {
                                type: "edit",
                                onClick: () => {
                                    addressModal.show({
                                        actionName: "edit",
                                        initData: r.address,
                                        countryCode,
                                        onConfirm: (address) => onReplace(r, address),
                                        controls: [
                                            r.type === "replace" && {
                                                label: "Reset",
                                                onClick: async ({closeModal}) => {
                                                    if (await confirmDialog.show({
                                                        message: "This will reset any changes you have made to this record",
                                                    })) {
                                                        onReset(r);
                                                        closeModal();
                                                    }
                                                },
                                            }
                                        ].filter(v=>v),
                                    });
                                },
                                xdQaName: "Build Address List "+address,
                            },
                            {
                                type: "delete",
                                onClick: async () => {
                                    await onDelete(address, r);
                                },
                                xdQaName: "Build Address List "+address,
                            },
                        ],
                    },
                ],
            };
        }),
        emptyAction: {
            label: "No address(es) found",
        },
        controls: [],
        xdQaNamePrefix: "Build Address List",
    })
);

const Columns = ({countryCode}) => [
    {
        width: "1%",
        label: "RECIPIENT NAME",
        type: "text",
        sortable: {
            defaultDirection: "asc",
        },
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "Build Address List Recipient Name",
        },
    },
    {
        width: "1%",
        label: "ADDRESS",
        type: "text",
        sortable: {
            defaultDirection: "asc",
        },
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "Build Address List Address",
        },
    },
    {
        width: "1%",
        label: "CITY",
        type: "text",
        sortable: {
            defaultDirection: "asc",
        },
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "Build Address List City",
        },
    },
    {
        width: "1%",
        label: countryCode === "CA" ? "PROVINCE" : "STATE",
        type: "text",
        sortable: {
            defaultDirection: "asc",
        },
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": countryCode === "CA" ? "Build Address List Province" : "Build Address List State",
        },
    },
    {
        width: "1%",
        label: "ZIP CODE",
        type: "text",
        sortable: {
            defaultDirection: "asc",
        },
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "Build Address List Zip Code",
        },
    },
    {
        width: "1%",
        label: "ACTION",
        type: "actions",
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "Build Address List Action",
        },
    },
];